<template>
  <Sitemap :menus="menus" />
</template>

<script setup>

const props = defineProps({
  menus: {
    type: Object,
    required: true,
  },
});

// Dynamically import the Download component
const Sitemap = defineAsyncComponent(() =>
  import(`@/components/apps/Sitemap.vue`)
);
</script>
